import { createAction } from 'redux-actions';

export const setListData = createAction('SET_LIST_DATA');
export const setListProducts = createAction('SET_LIST_PRODUCTS');
export const setListImages = createAction('SET_LIST_IMAGES');